








import Vue from 'vue';
import Component from 'vue-class-component';
import Navbar from '@/components/Navbar.vue';
import MyFooter from '@/components/Footer.vue';
import Amplify from 'aws-amplify';
import awsconfig from '@/aws-exports';
import cognitoConfig from '@/aws-cognito';

Amplify.configure(awsconfig);
Amplify.configure(cognitoConfig);

@Component({
  components: {
    Navbar,
    MyFooter,
  },
})
export default class App extends Vue {}
